export const DEFAULT_META_KEY = 'reducerId';
export const ERROR_403_PATH = '/403';
export const ERROR_404_PATH = '/404';
export const ERROR_500_PATH = '/500';

export const requiredBaseRule = { required: 'Поле обязательно для заполнения' };
export const requiredContractChangeApprovedRule = {
    required: 'Поле обязательно для заполнения при переводе в статус "Согласован"',
};

export const EMPTY_OTHER_FORMULA_MSG = 'Необходимо задать формулу расчета для создания Наряд-Заказа';
export const EMPTY_OTHER_TYPE_MSG = 'Необходимо заполнить тип прочих затрат для создания Наряд-Заказа';
export const EMPTY_DRAFT_OTHER_TYPE_MSG =
    'Необходимо заполнить обязательные параметры записи «Черновик» для работы с Наряд-Заказами';

export const MIME_TYPES = {
    OTHER: 'application/octet-stream',
    XLS: 'application/vnd.ms-excel',
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    PDF: 'application/pdf',
    ZIP: 'application/zip',
    XML: 'application/xml',
    CSV: 'text/csv',
    JPEG: 'image/jpeg',
    PNG: 'image/png',
};

export const PATH_BY_REQUEST_CODE: Record<number, string> = {
    403: ERROR_403_PATH,
    500: ERROR_500_PATH,
};
